/* eslint-disable react/prop-types */
import React from "react"
import { Redirect } from "react-router"
import { useParams } from "react-router-dom"
import { formatRoute } from "react-router-named-routes"
import { branch, compose, renderComponent, withProps } from "recompose"
import { graphql } from "@apollo/client/react/hoc"
import moment from "moment"
import EmployeeCaseSummary from "./"
import { archiveCaseMutation } from "../../apollo/mutations"
import { CASE_DETAIL_QUERY } from "../../apollo/queries"
import routes from "../../routes"

const OpenCaseRedirect = (props) => (
  <Redirect
    to={formatRoute(routes.openCases, {
      facilityId: props.facilityId,
    })}
    push={true}
  />
)

const ArchivedCaseRedirect = (props) => (
  <Redirect
    to={formatRoute(routes.archivedCases, {
      facilityId: props.facilityId,
    })}
    push={true}
  />
)

const EmployeeCaseSummaryEnhanced = compose(
  withProps(() => {
    const { facilityId, caseId } = useParams()
    return {
      facilityId,
      caseId,
    }
  }),
  graphql(CASE_DETAIL_QUERY, {
    options: ({ facilityId, caseId }) => ({
      variables: { facilityId, caseId },
    }),
    props: ({ data: { error, loading, facility } }) => {
      if (error) throw error

      if (loading) return { loading }

      if (facility.contactTracingCases.length === 0) throw Error("404")

      const subject = facility.contactTracingCases[0].subjects[0]

      return {
        archivedAt: facility.contactTracingCases[0].archivedAt,
        name: subject.entity.name,
        startAt: moment.parseZone(subject.startAt),
        endAt: moment.parseZone(subject.endAt),
        subjects: facility.contactTracingCases[0].subjects.map((subject) => ({
          entityName: subject.entity.name,
          entityId: subject.entity.id,
          startAt: moment.parseZone(subject.startAt),
          endAt: moment.parseZone(subject.endAt),
        })),
        id: facility.contactTracingCases[0].id,
      }
    },
  }),
  archiveCaseMutation,
  branch(
    ({ archiveData }) =>
      archiveData && archiveData.putContactTracingCase.archivedAt !== null,
    renderComponent(OpenCaseRedirect)
  ),
  branch(
    ({ archiveData }) =>
      archiveData && archiveData.putContactTracingCase.archivedAt === null,
    renderComponent(ArchivedCaseRedirect)
  )
)(EmployeeCaseSummary)

export default EmployeeCaseSummaryEnhanced
